import React from 'react';
import Migalha from './migalha';

import {NavLink } from 'react-router-dom';



export default class Master extends React.Component {

    componentDidMount() {
    
    }

    render() {
        return (
            <div>
                {/* <ul className='menu-anjo'>
                    <li> <NavLink exact activeClassName="selected" to="/" >Sobre</NavLink > </li>
                    <li> <NavLink  exact activeClassName="selected"to="/ficha-inscricao" >Ficha de Inscrição</NavLink > </li>
                    <li> <NavLink  exact  activeClassName="selected" to="/solicitar-voluntarios" >Solicitar Voluntários</NavLink > </li>
                </ul>             */}
                <main>
                    {this.props.children}
                </main>
            </div>
        );
    }
};